var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"success"}},[_vm._v(" Thank you! "),_c('a',{attrs:{"href":""}},[_vm._v("Secret link 1")]),_c('a',{attrs:{"href":""}},[_vm._v("Secret link 2")])])
}]

export { render, staticRenderFns }